import { BetaFeatures } from "hooks/useBetaFeatures";

import { DashboardCapabilities } from "models/dashboard";
import { WorkspaceDashboard } from "models/workspace";

import {
  TypeWellDetailsWidgetKey,
  TypeWellEditorWidgetKey
} from "../constants/widgets.constants";

export const getWorkspaceDashboardCapabilities = (
  dashboard: WorkspaceDashboard,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  hasFeature: (feature: BetaFeatures) => boolean
): DashboardCapabilities => {
  let hasMapWidget = false;
  let hasXdaWidget = false;
  let hasSingleWellWidget = false;
  let hasThreeDWidget = false;
  let hasMultiProductWidget = false;
  let hasWellCardWidget = false;
  let hasTypeWellEditorWidget = false;
  let hasTypeWellDetailsWidget = false;
  let hasFacilityTicketWidget = false;
  let hasTypeLogWidget = false;
  let hasMidstreamWidget = false;

  if (dashboard && dashboard.widgetTypes?.length > 0) {
    hasMapWidget = dashboard.widgetTypes.filter((type) => type === "map").length > 0;

    hasXdaWidget = dashboard.widgetTypes.filter((type) => type === "xda").length > 0;

    hasSingleWellWidget =
      dashboard.widgetTypes.filter(
        (type) => type === "info" || type === "completion" || type === "survey-vis"
      ).length > 0;

    hasThreeDWidget =
      dashboard.widgetTypes.filter((type) => type === "threed").length > 0;

    hasMultiProductWidget =
      dashboard.widgetTypes.filter((type) => type === "multiphase-chart").length > 0;

    hasWellCardWidget =
      dashboard.widgetTypes.filter((type) => type === "well-card").length > 0;

    hasFacilityTicketWidget =
      dashboard.widgetTypes.filter((type) => type === "facility-ticket").length > 0;

    hasTypeLogWidget =
      dashboard.widgetTypes.filter((type) => type === "type-log").length > 0;

    hasTypeWellEditorWidget =
      dashboard.widgetTypes.filter((type) => type === TypeWellEditorWidgetKey).length > 0;

    hasTypeWellDetailsWidget =
      dashboard.widgetTypes.filter((type) => type === TypeWellDetailsWidgetKey).length >
      0;

    hasMidstreamWidget =
      dashboard?.widgetTypes.filter(
        (type) => type === "facility-ticket" || type.includes("midstream")
      ).length > 0;
  }

  return {
    hasMapWidget,
    hasXdaWidget,
    hasSingleWellWidget,
    hasThreeDWidget,
    hasMultiProductWidget,
    hasWellCardWidget,
    hasFacilityTicketWidget,
    hasTypeLogWidget,
    hasTypeWellEditorWidget,
    hasTypeWellDetailsWidget,
    hasMidstreamWidget
  };
};
